import { Typography } from 'antd';
import { checkForSuperAdmin } from '../../utils/checkRole';

export const REPORT_TYPES = ['internal', 'external', 'combined'];

/** Filter options of the two columns, keyed like the columns (the Orders page's filteredInfo / filterOptions keys). */
export const getReportFilterOptions = t => ({
    reportType: REPORT_TYPES.map(type => ({ text: t(`jobs:reportTypes.${type}`), value: type })),
    internalDb: [
        { text: t('jobs:internalDb.yes'), value: 'yes' },
        { text: t('jobs:internalDb.no'), value: 'no' },
    ],
});

// SC-QA-91: whether the internal DB has enough data on the car (the API's `internalDataAvailable`), whatever report type
// was ordered: "Available" / "Unavailable", or a dash when the internal DB could not answer
const internalDbLabel = (available, t) => {
    if (available === true) return t('jobs:internalDb.yes');
    if (available === false) return t('jobs:internalDb.no');
    return '—';
};

const buildReportTypeColumn = ({ t, textStyle, headerFilter }) => ({
    title: t('fields.reportType'),
    dataIndex: 'type',
    key: 'reportType',
    width: 130,
    ...headerFilter('reportType'),
    render: type => <Typography.Text style={textStyle}>{type ? t(`jobs:reportTypes.${type}`) : '—'}</Typography.Text>,
});

const buildInternalDbColumn = ({ t, textStyle, headerFilter }) => ({
    title: t('fields.internalDb'),
    dataIndex: 'internalDataAvailable',
    key: 'internalDb',
    width: 110,
    ...headerFilter('internalDb'),
    render: available => <Typography.Text style={textStyle}>{internalDbLabel(available, t)}</Typography.Text>,
});

/**
 * Orders table, Super Admins only: the type of report each order asked for and whether the internal vehicle DB has data
 * on the car, after "Ordered by" (or the VIN), on both tabs. Both are filtered on the API, from `filteredInfo`.
 * On small screens the header filters are off and the mobile filters drawer offers the same options.
 */
export const withReportColumns = (columns, { currentUser, t, textStyle, filteredInfo, showHeaderFilters }) => {
    if (!checkForSuperAdmin(currentUser)) {
        return columns;
    }

    const filterOptions = getReportFilterOptions(t);
    const headerFilter = key => ({
        filters: showHeaderFilters ? filterOptions[key] : null,
        filteredValue: filteredInfo[key]?.length ? filteredInfo[key] : null,
    });
    const reportColumns = [buildReportTypeColumn, buildInternalDbColumn].map(build =>
        build({ t, textStyle, headerFilter })
    );

    const anchorIndex = columns.findIndex(column => column.key === 'orderedBy');
    const insertAt = (anchorIndex === -1 ? columns.findIndex(column => column.key === 'vin') : anchorIndex) + 1;

    return [...columns.slice(0, insertAt), ...reportColumns, ...columns.slice(insertAt)];
};
